/**
 * Saint Helena pound.
 */
export var SHP = {
  code: 'SHP',
  base: 10,
  exponent: 2
};